export default "__VITE_ASSET__RdMl4QdD__";